export default __webpack_public_path__ + "static/media/logo_large.8753a200.png";